import LinkTable from './LinkTable';

export default LinkTable;
